module.exports = __webpack_public_path__ + "img/gb9120_1_n.prt.16fc1d1d.jpg";